import { $selectedObjects } from '../stores/selectionStore';
import { SelectedObjectFields } from './SelectedObjectFields';
import { useStore } from '@nanostores/react';

export function SelectionPanel() {
  const selectedObjects = useStore($selectedObjects);
  const selectedCount = selectedObjects.length;
  const selectedObject = selectedCount === 1 ? selectedObjects[0] : undefined;

  return (
    <aside className="pointer-events-auto flex max-h-full min-h-0 max-w-sm min-w-55 flex-col rounded-xl border border-white/20 bg-[#08111fcc] px-3.5 py-3 backdrop-blur-sm">
      <p className="mb-2 text-xs tracking-[0.12em] text-white/80 uppercase">
        Selection
      </p>
      <p className="text-[0.95rem] leading-[1.4]">
        Selected objects: {selectedCount}
      </p>
      {selectedObject ? <SelectedObjectFields object={selectedObject} /> : null}
    </aside>
  );
}
